<template>
  <div class="page border-box"  v-wechat-title="$route.meta.title">
    <div class="top-tit">
      <div class="top-tit1">{{videoInfo.name}}</div>
      <div class="top-tit2 clearfix">
        成都大运会组委会 | 成都网传文化
        <span class="fr">{{videoInfo.listen | initNumber}}播放</span>
      </div>
    </div>
    <div class="top-box" :class="full?'curr':''">
      <div class="top-video">
        <video id="myVideo" class="video_box" width="100%" loop="loop" webkit-playsinline="true" x5-video-player-type="h5-page" x5-video-player-fullscreen="true" playsinline=""
               preload="auto"  :src="videoInfo.url" controls  disablePictureInPicture="true" controlslist="nodownload nofullscreen noremoteplayback noremoteplayback noremote footbar"
               :poster="videoInfo.img" @click="playVideo"></video>
               <!--:poster="videoInfo.img" @play="videoPlay" @pause="videoPause" @click="playVideo"></video>-->
        <!--<img class="icon-video" src="../../assets/icon_play_btn03.png" alt="" v-if="playing!=1" @click="playVideo">-->
        <img class="icon-fulls" src="../../assets/fulls.png" alt="" @click="fullClick()">
      </div>
    </div>
    <div class="video-info">

      <div class="slide-con">
        <div class="slide-top box">
          <img class="l img" :src="videoInfo.guideimg" alt="">
          <div class="r flex">
            <div class="name hide">{{videoInfo.guide}}</div>
            <div class="time">{{videoInfo.guidetag}}</div>
          </div>
        </div>
        <!--<div class="num-box clearfix">-->
          <!--<span>{{videoInfo.listen | initNumber}}播放量</span>-->
          <!--<span>{{videoInfo.uptime}}</span>-->
        <!--</div>-->

        <div class="title clearfix">
          <div class="left"><h1 :class="slideState==1?'spread':''">视频信息</h1></div>
          <div class="right" :class="slideState==1?'curr':''" @click="slideFun"><img src="../../assets/icon-down1.png" alt=""></div>
        </div>

        <!--<div class="txt" v-if="slideState==1" v-html="videoInfo.content"></div>-->
        <!--景区详情内容-->
        <div class="txt" v-if="slideState==1">
          <!--<div class="scenic-padding border-box">-->
           <!---->
          <!--</div>-->
          <!--<div class="scenic-padding border-box">-->
            <!--<div class="scenic-details-title">景区地址</div>-->
            <!--<div class="scenic-details-info">{{videoInfo.address}}</div>-->
            <!--<div class="scenic-details-title border-box">门票价格</div>-->
            <!--<div class='scenic-details-info'>{{videoInfo.special=='0'?'免费':videoInfo.special}}</div>-->
            <!--<div class="scenic-details-title border-box">开放时间</div>-->
            <!--<div class="scenic-details-info">{{videoInfo.time}}</div>-->
          <!--</div>-->
          <div class="scenic-padding scenic-details-box border-box">
            <div class="scenic-details-title">景区地址</div>
            <div class="scenic-details-info">{{videoInfo.address}}</div>

            <div class="scenic-details-title border-box">门票价格</div>
            <div class='scenic-details-info'>{{videoInfo.special=='0'?'免费':videoInfo.special}}</div>

            <div class="scenic-details-title border-box">开放时间</div>
            <div class="scenic-details-info">{{videoInfo.time}}</div>

            <div class="scenic-details-title border-box">交通信息</div>
            <div class="scenic-details-info" v-if="(videoInfo.trans=='')||(videoInfo.trans==null)||(!videoInfo.trans)">暂无信息</div>
            <div class="scenic-details-info" v-html="videoInfo.trans" v-else></div>

            <div class="scenic-details-title border-box">景区信息</div>
            <div class="scenic-details-info" v-if="(videoInfo.content=='')||(videoInfo.content==null)||(!videoInfo.content)">暂无景区信息</div>
            <div id="videoInfoC" class="scenic-details-info" v-html="videoInfo.content" v-else></div>
          </div>
        </div>
      </div>
    </div>

    <div class="list border-box">
      <div class="item border-box box" v-for="(item,index) in root" @click="toDesc(item)">
        <div class="l">
          <img class="img" :src="item.img" alt="">
          <span class="time">{{item['2'] | initTime}}</span>
        </div>
        <div class="flex r">
          <div class="name hide">{{item.name}}</div>
          <div class="name1">{{item.guide}} <font>• {{item.guidetag}}</font></div>
          <div class="name1 hide">{{item.time}}</div>
          <div class="num-box hide">{{item.listen | initNumber}}播放</div>
        </div>
      </div>
      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>



  </div>

</template>

<script>
  import {videoCDesc, videoCList2, videoCListen } from "@/service/getData";
  import {wxGetPosition,getCityInfo,wxShareme,wxOpenMapLocation} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import Swiper from '../../components/Swiper'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        id: this.$route.query.id || '',//视频id
        siteid: this.$route.query.siteid || '',//站点id
        sregion: this.$route.query.sregion || '',//省站点id:430000
        userInfo: {}, //用户信息
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        tabState:1,//分类
        full: 0, //1全屏
        currVideo: '',
        slideState:0,//0：收缩 1：展开
        playing:0,//
        page:1,
        rows: 20,
        root: [],
        loadText: "数据加载中",
        videoInfo:{
          "channelName":"绝美风景",
          "id":32308,
          "title":"街子古镇",
          "lnglat":[103.549982,30.813654],
          "imgUrl":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650352765000_街子古镇.jpg",
          "url":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650352718000_街子古镇 ver.1.1（中英）.mp4",
          "guide": '', //导游
          "tag": '', //导游标签
          "content": '这里是街子古镇，这是街子古镇的简介，这是街子古镇的简介，这是街子古镇的简介，这是街子古镇的简介，这是街子古镇的简介，这是街子古镇的简介', //html富文本简介内容
          "desc": '', //html富文本讲解词
        },
        list:[
          {
            "channelName":"网红打卡",
            "id":32302,
            "title":"东郊记忆",
            "lnglat":[104.122906,30.668697],
            "imgUrl":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650448545000_东郊记忆.jpg",
            "url":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650448497000_东郊记忆ver.1.2（中英）.mp4"
          },
          {
            "channelName":"成都美食",
            "id":32446,
            "title":"青城美食",
            "lnglat":'',
            "imgUrl":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650350493000_青城美食.png",
            "url":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650350428000_青城美食ver.1.1（中英）.mp4"
          },
          {
            "channelName":"成都美食",
            "id":32444,
            "title":"郫县豆瓣",
            "lnglat":'',
            "imgUrl":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650350401000_郫县豆瓣.jpg",
            "url":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650350353000_郫县豆瓣 ver.1.1（中英）.mp4"
          },
          {
            "channelName":"成都美食",
            "id":32448,
            "title":"邛崃酒",
            "lnglat":'',
            "imgUrl":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650350677000_邛崃酒.jpg",
            "url":"https://file.daqctc.com/shortVideo/daqctc/56/input/1650350524000_邛崃酒ver.1.1（中英）.mp4"
          }
        ]
      }
    },
    computed: {

    },
    beforeRouteLeave(to, from, next) {
      if(this.full==1){
        this.full = 0;
        next(false);
      }else {
        next();
      }
    },
    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.videoCList2Fun(this.page);
      this.videoCDescFun();

      window.addEventListener("scroll",this.handleFun);

      window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function() {
        if (window.orientation === 180 || window.orientation === 0) {
          console.log("竖屏");
          this.full = 0;
        }
        if (window.orientation === 90 || window.orientation === -90 ){
          console.log("横屏");
          this.full = 1;
        }
      }, false);

    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      window.removeEventListener("onorientationchange");
      window.removeEventListener("resize");
    },

    methods: {

      async videoCList2Fun(page){

        let res = await videoCList2({
          TimeStamp: this.TimeStamp,
          page: page,
          rows: this.rows,
          id: this.id
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          var root = res.data.root

          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }


        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.videoCList2Fun(page);
          });
        })
      },

      //获取相关联的展馆数据
      async videoCDescFun(){
        let res = await videoCDesc({
          id: this.id
        });
        if(res.errcode == '00000'){
          this.videoInfo = res.data;
          this.$route.meta.title = res.data.name;

          let title = '导游带您游成都——'+res.data.name;
          let desc = (res.data.guidetag||'')+' '+res.data.guide + '@你：我正在“金牌解说”，一起来听景区故事吧';
          let link = '/video-list-cd-detail?id='+ this.id +'&appKey='+(this.appKey);
          let img = res.data.img;
          wxShareme(title,desc,img,link);
        }



        let res1 = await videoCListen({
          id: this.id
        });
      },


      openVideo: function (item){
        this.currVideo = item;
        var Video = document.getElementById("myVideo");
        if(Video && Video.paused){
          Video.play();
        }
        this.playing = 1;
        this.full = 1;
      },
      //关闭
      fullClick1: function(){
        this.currVideo = '';
        var Video = document.getElementById("myVideo");
        if(Video && !Video.paused){
          Video.pause();
        }
      },

      //全屏
      fullClick: function(){
        var Video = document.getElementById("myVideo");
        if(Video.paused){
          Video.play();
          this.playing = 1;
        }
        if(this.full==1){
          this.full = 0;
        }else {
          this.full = 1;
        }
      },
      //播放或暂停
      playVideo(){
        var Video = document.getElementById("myVideo");
        if(this.playing != 1){
          Video.play();
          this.playing = 1;
        }else {
          Video.pause();
          this.playing = 0;
        }

      },

      videoPlay(){
        var Video = document.getElementById("myVideo");
        Video.play();
        this.playing = 1;
      },
      videoPause(){
        var Video = document.getElementById("myVideo");
        Video.pause();
        this.playing = 0;
      },
      //展开收缩
      slideFun:function(){
        var self = this;
        if(this.slideState == 1){
          this.slideState = 0;
        }else {
          this.slideState = 1;
        }

      },

      //打开地图
      openMap: function (lnglat,title){
        wxOpenMapLocation(lnglat[1], lnglat[0], title, '');
      },

      //切换分类
      tabStateFun:function(state){
        this.tabState = state;
      },

      //跳转视频详情
      toDesc:function(item){

        this.id = item.id;
        this.page = 1;
        this.page = 1;
        this.playing = 0;

        this.videoCList2Fun(this.page);
        this.videoCDescFun();

        this.$router.replace({
          path: `/video-list-cd-detail?${'id='+ item.id }`
        });

      }

    },
    watch:  {},
    components: {Swiper},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  video::-webkit-media-controls-fullscreen-button {display: none;}
  video::-webkit-media-controls-play-button { display: none;}
  .page{ padding-bottom: .2rem;background: #fff; }
  .top-box{position: relative;z-index:1;width: 100%;height: 56.25vw;background: #282828;overflow: hidden;}
  .top-video{ position: relative;width: 100%;height: 100%;display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center;
    -webkit-box-align: center; -ms-flex-align: center; align-items: center }
  .top-box video{width: 100%;height: 100%;object-fit: contain;background: #000;vertical-align: baseline;}
  .top-box .icon-video{position: absolute;top:50%;left: 50%;z-index:1;width: .72rem;height: .72rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .top-box .icon-fulls{position: absolute;right: .23rem; top: .23rem; z-index: 1; width: .52rem; height: .52rem;background: none;}

  .top-box.curr{position: fixed;left:0;top:0;right:0;bottom:0; width: 100%; height: 100%;z-index: 999;}
  .top-box.curr .top-video video{width: 100vh;height:100vw;-webkit-transform: rotate(90deg); transform: rotate(90deg); }
  .top-box.curr .top-video .icon-fulls{bottom: 0.23rem; top: auto; }

  .video-info{padding: 1.86667vw 3.2vw 2.93333vw;font-size: 0;border-bottom: 1px solid #e7e7e7;background-color: #282828;}
  .video-info .title{margin-top: 3vw;}
  .video-info .title .left {width: 86.66667vw;float: left;position: relative;}
  .video-info .title .left h1 {font-size: .32rem;display: inline-block;-webkit-box-sizing: border-box;box-sizing: border-box;color: #fff;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 86.66667vw;height: 6.4vw;line-height: 6.4vw;}
  .video-info .title .left h1.spread {display: inline;white-space: normal;height: auto;}
  .video-info .title .right {float: right;width: 6.4vw;height: 6.4vw;}
  .video-info .title .right img{display:block;width: 4vw;height: 3vw;margin: 1.7vw auto 0;object-fit: contain;vertical-align: top;transition: -webkit-transform .1s;-webkit-transition: -webkit-transform .1s;transition: transform .1s;transition: transform .1s,-webkit-transform .1s;-webkit-transform-origin: center;transform-origin: center;}
  .video-info .title .right.curr img{-webkit-transform: rotate(-180deg);transform: rotate(-180deg);}
  .slide-top{padding-top: 2.93333vw;}
  .slide-top .img{width: 9.6vw;height: 9.6vw;margin-right: 2.66667vw;border-radius: 50%;border: 0.5px solid #999;}
  .slide-top .name{display: block;height: 4.53333vw;line-height: 4.53333vw;font-size: 3.73333vw;color: #fff; }
  .slide-top .time{height: 3.2vw;line-height: 3.2vw;margin-top: 1.33333vw;font-size: 3.2vw;color: #fff;}
  .slide-con .num-box{font-size: 3.2vw;line-height:3.2vw;margin-top: 2.66667vw;color: #fff;}
  .slide-con .num-box span{float:left;display: inline-block;vertical-align: middle;margin-right: 2.13333vw;}
  .slide-con .txt{font-size: 3.2vw;line-height: 4.8vw;color: #999;}

  .list{padding: 0 3.2vw;}
  .list .item{padding: 2vw 0;border-bottom: 1px solid #e7e7e7;}
  .list .item .l{position:relative;width: 36vw;height: 1.8rem;margin-right: .24rem;border-radius: 0.12rem;overflow: hidden;}
  .list .item .r{position:relative;height: 1.8rem;}
  .list .item .time{position: absolute;right:0;bottom:.12rem;padding:0 .12rem;border-radius:.04rem 0 0 .04rem;font:.2rem/.32rem "Microsoft YaHei";color:#fff;background: rgba(0,0,0,.3);}
  .list .item .name{height:.48rem;font:.28rem/.48rem "Microsoft YaHei";color: #000; }
  .list .item .name1{font:.24rem/.42rem "Microsoft YaHei";color: #999; }
  .list .item .num-box{position: absolute;bottom: 0;left: 0;width: 100%;height: .46rem;font:.24rem/.44rem "Microsoft YaHei";color: #999;}

    /*全景视频*/
  .video-vr{padding: 0 .24rem .4rem;}
  .video-vr-con{ float:left;width: 49%;margin-top: .16rem; border-radius: .08rem;box-shadow: 0 0 0.1rem #ddd;overflow: hidden;}
  .video-vr-con:nth-of-type(2n+1){margin-right: 2%;}
  .video-vr-top{display: block; position:relative;width: 100%; height: 30vw;border-radius: .08rem .08rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .08rem .08rem 0 0;object-fit: cover; overflow: hidden;}
  .video-vr-mask{position: absolute;z-index: 1;bottom:0;left: 0;width: 100%;height: .52rem;padding:0 .16rem;
    /*background: rgba(0,0,0,.3);*/
    background: -webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.85)),to(transparent));
    background: linear-gradient(0deg,rgba(0,0,0,.85),transparent);
    font: .2rem/.52rem "Microsoft YaHei";color: #fff;}
  .video-vr .icon_360{width: .32rem;height: .32rem;margin-right:.06rem;margin-top:.1rem;vertical-align: top;object-fit: contain;}
  .video-vr-bot{position:relative;width:100%;padding: .1rem .16rem; background: #fff;}
  .video-vr-name{height:.84rem;color: #212121;font:.26rem/.42rem "Microsoft YaHei";}
  /*.page.VR .buy-btn{ top: .1rem; background: none; }*/
  /*.page.VR .buy-btn svg{ width: .45rem;height: .45rem;}*/

  .pvideo{display:none;position: fixed;right: 0;top: 0;z-index: 1;width: 100vw;height: 100vh;background-color: #eee;pointer-events: none;}
  .pvideo.curr{display:block;pointer-events: auto;}
  .pvideo-top{position: relative;width: 100%;height: 100%;display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center;
    -webkit-box-align: center; -ms-flex-align: center; align-items: center}
  .pvideo-top video{width: 100%;height: 100%;object-fit: cover;vertical-align: baseline;background-color: #000;}
  .pvideo-top .icon-video{position: absolute;left: 50%;top: 50%;z-index:9;width: .72rem;height: .72rem;transform: translate(-50%,-50%);background: none;pointer-events: none;}
  .pvideo-top .icon-fulls{position: absolute;right: .23rem; top: .23rem; z-index: 1; width: .52rem; height: .52rem;background: none;}

  .pvideo-box.curr{position: fixed;left:0;top:0;right:0;bottom:0; width: 100%; height: 100%;z-index: 999;}
  .pvideo-box.curr .pvideo-top video{width: 100vh;-webkit-transform: rotate(90deg); transform: rotate(90deg); }
  .pvideo-box.curr .pvideo-top .icon-fulls{bottom: 0.23rem; top: auto; }

  /*新版景区景点详情*/
  .scenic-details-box{position:relative;}
  .scenic-details-box.curr .scenic-details{height:auto;}
  .scenic-details-title{position:relative;font-size:.3rem;color:#fff;margin-top:.2rem;font-weight: 600}
  .scenic-details-info{line-height:.4rem;font-size: .24rem;font-weight: normal;color:#fff;margin-top:.06rem;}
  #videoInfoC .scenic-details-info p, #videoInfoC .scenic-details-info span{line-height:.4rem!important;font-size: .24rem!important;font-weight: normal!important;color:#fff!important;}

  .top-tit{padding: .3rem 3.2vw .26rem;background-color: #282828;}
  .top-tit .top-tit1{ font-size: .34rem; font-weight: bold;color: #fff; }
  .top-tit .top-tit2{ margin-top: .12rem; font-size: .24rem; color: #e5e5e5; }
</style>
<style>
  .page.VR .psv-container{ position: absolute; padding: 1px; left:-1px; top:-1px; right:-1px; bottom:-1px; }
  .banner-box .swiper-box .swiper-pagination {left: initial;right: 5%;width: auto;}
  .banner-box .swiper-pagination-bullet-active{width: .08rem;}
  #videoInfoC .scenic-details-info p, #videoInfoC .scenic-details-info span{line-height:.4rem!important;font-size: .24rem!important;font-weight: normal!important;color:#fff!important;}
</style>



// WEBPACK FOOTER //
// src/page/video-vrlist/video-list-cd-detail.vue